<template>
  <div class="tab-wrap">
    <!-- 탭메뉴 -->
    <tabMenu />
    <!-- <div class="scrollX">
      <ul class="investList-menu" flex>
        <router-link :to="{ name: 'RateToReturn' }">
          <li>
            {{ $t("RateToReturn.assetsStatus") }}
          </li>
        </router-link>
        <router-link :to="{ name: 'TransactionHistory' }">
          <li>
            {{ $t("RateToReturn.TransactionHistory") }}
          </li>
        </router-link>
        <router-link :to="{ name: 'RebaseList' }">
          <li class="active">
            {{ $t("gnb.rebaseList.name") }}
          </li>
        </router-link>
        <router-link :to="{ name: 'RebaseORICList' }">
          <li>
            {{ $t("gnb.rebaseORICList.name") }}
          </li>
        </router-link>
      </ul>
    </div> -->
    <!-- <vs-tabs vs-alignment="center" :value="$route.query.activeTab"> -->
    <div class="list-container">
      <vs-tab v-if="false" :label="$t('gnb.transactionHistory.menu.asset')">
        <!-- 자산탭//S -->
        <div class="well well-black my-asset text-center">
          <dl class="dl-horizontal">
            <dt>{{ $t("sideMenu.totalAsset") }}</dt>
            <dd>
              <strong>{{ totalAssetToKRW | formatNumber }}</strong>
              <small>KRW</small>
            </dd>
          </dl>
        </div>
        <div class="my-asset-list"></div>
      </vs-tab>

      <!-- <div>
      <p class="coin-name">{{$t("gnb.rebaseList.coinName")}}</p>
    </div> -->

      <!-- <div>
      <p class="rebase-title">
        {{$t('gnb.rebaseList.name')}}
      </p>
    </div> -->

      <div v-if="tradingHistory.length > 0">
        <div
          class="table"
          v-for="(tradingList, index) in tradingHistory"
          :key="index"
        >
          <div class="table-wrap">
            <div class="rate">
              <div class="text">{{ $t("gnb.rebaseList.rate") }}</div>
              <div class="number">
                {{
                  tradingList.rRebaseRate * 100 < 0 &&
                  tradingList.rRebaseRate * 100 > -1
                    ? "-"
                    : ""
                }}{{ (tradingList.rRebaseRate * 100) | formatNumber2(8) }} %
              </div>
            </div>
            <div class="amount">
              <div class="text">{{ $t("gnb.rebaseList.amount") }}</div>
              <div class="number">
                {{
                  tradingList.rRebaseAmount < 0 &&
                  tradingList.rRebaseAmount > -1
                    ? "-"
                    : ""
                }}{{ tradingList.rRebaseAmount | formatNumber2(8) }}
                {{ tradingList.ciCode }}
              </div>
            </div>
            <!-- <div class="total">
            <div class="text">{{ $t("gnb.rebaseList.total") }}</div>
            <div class="number">{{ tradingList.rCurrentAmount | formatNumber2(8) }} {{ tradingList.ciCode }}</div>
          </div> -->
            <div class="time">
              <div class="text">{{ $t("trade.log.Time") }}</div>
              <div class="number">{{ tradingList.rRebaseTime }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="empty">
        <p style="margin: 200px 0; text-align: center; font-size: 12px">
          {{ $t("ieo.history.empty") }}
        </p>
      </div>
      <Pagination
        v-if="tradingHistory.length != 0"
        :current-page="tradingHistoryPage.currentPage"
        :total-page="tradingHistoryPage.totalPage"
        @next-page="nextPage('getTradingHistory')"
        @prev-page="prevPage('getTradingHistory')"
        class="mb20"
      >
      </Pagination>
      <!-- 거래탭//E -->
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import Store from "@/store/";
import Numeral from "numeral";
import Decimal from "decimal.js";

import Pagination from "@/components/common/pagination";
import TabMenu from "@/components/investments/tabMenu";

export default {
  created() {},
  data() {
    return {
      actives: 0,
      tradeStartDate: this.moment()
        .subtract(1, "M")
        .format("YYYY-MM-DD"),
      tradeEndDate: this.moment().format("YYYY-MM-DD"),
      KRWStartDate: this.moment()
        .subtract(1, "M")
        .format("YYYY-MM-DD"),
      KRWEndDate: this.moment().format("YYYY-MM-DD"),
      coinStartDate: this.moment()
        .subtract(1, "M")
        .format("YYYY-MM-DD"),
      coinEndDate: this.moment().format("YYYY-MM-DD"),
      tradingHistory: [],
      krwDepositWithdrawLists: [],
      coinDepositWithdrawLists: [],
      /** pagenation */
      tradingHistoryPage: {
        currentPage: 1,
        totalPage: 1,
        method: this.getTradingHistory,
      },
      krwHistoryPage: {
        currentPage: 1,
        totalPage: 1,
        method: this.getKRWHistory,
      },
      coinHistoryPage: {
        currentPage: 1,
        totalPage: 1,
        method: this.getCoinHistory,
      },
      selectedCoin: 2,
      options1: [
        { text: "IT", value: 0 },
        { text: "Blade Runner", value: 1 },
        { text: "Thor Ragnarok", value: 2 },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "totalAssetToKRW",
      "marketsByDealCoin",
      "totalAvailToKRW",
      "toKRW",
      "wallet",
      "coinWallet",
    ]),
    ...mapState(["Server"]),
    coins() {
      return _.map(this.wallet, (wallet) => {
        return {
          name: wallet.coin.name,
          img: `//static.flybit.com/static/img/mobile/coin_${wallet.coin.code}.png`,
          amount: wallet.total,
          tokrw: new Decimal(this.toKRW(this.$bnCode(wallet.coin.code)).price)
            .mul(wallet.total)
            .toNumber(),
          available: wallet.available,
          code: wallet.coin.code,
          active: wallet.coin.enable === "Y",
          availMarkets: (code) => {
            const availMarkets = _.get(
              this.marketsByDealCoin,
              wallet.coin.code,
              []
            ).map((market) => market.baseCoinCode);
            return availMarkets.includes(code);
          },
        };
      });
    },
    coinList() {
      const coinList = this._.map(this.$store.state.Market.coin).filter(
        (coins) => coins.code !== "KRW"
      );
      return _.sortBy(coinList, ["sort"]);
    },
    ciCoinInfo() {
      return this.$store.getters.getCoinSetting("AMPL");
    },
  },
  mounted() {
    this.getTradingHistory();
    this.getKRWHistory();
    this.getCoinHistory();
  },
  methods: {
    getTradingHistory() {
      const params = {
        cidx: this.ciCoinInfo.id,
        completed: "Y",
        // fromDate: this.moment(this.tradeStartDate).toISOString(),
        // toDate: this.moment(this.tradeEndDate).toISOString(),
        page: this.tradingHistoryPage.currentPage,
        count: 10,
      };

      this.$api.rebaseHistory(params).then((response) => {
        this.tradingHistoryPage.totalPage =
          response.pagination.totalPages === 0
            ? 1
            : response.pagination.totalPages;
        this.tradingHistory = response.body;
      });
    },
    getKRWHistory() {
      const params = {
        fromDate: this.moment(this.KRWStartDate).toISOString(),
        toDate: this.moment(this.KRWEndDate).toISOString(),
        page: this.krwHistoryPage.currentPage,
        count: 10,
      };
      return this.$api.Transfer.getKRWTransferHistory(params).then(
        (response) => {
          this.krwHistoryPage.totalPage =
            response.pagination.totalPages === 0
              ? 1
              : response.pagination.totalPages;
          this.krwDepositWithdrawLists = response.body;
        }
      );
    },
    getCoinHistory() {
      const params = {
        fromDate: this.moment(this.coinStartDate).toISOString(),
        toDate: this.moment(this.coinEndDate).toISOString(),
        page: this.coinHistoryPage.currentPage,
        count: 10,
      };
      return this.$api.Transfer.getTransferHistory(params).then((response) => {
        //this.coinDepositWithdrawLists = response.body;
        this.coinHistoryPage.totalPage =
          response.pagination.totalPages === 0
            ? 1
            : response.pagination.totalPages;
        this.coinDepositWithdrawLists = _.map(response.body, (row) => {
          return {
            ...row,
            coinCode: _.get(Store.getters, ["coinIdMap", row.coinId, "code"]),
          };
        });
      });
    },
    nextPage(board) {
      const page = this.getPagination(board);
      if (page.currentPage < page.totalPage) {
        page.currentPage++;
        page.method();
      }
    },
    prevPage(board) {
      const page = this.getPagination(board);
      if (page.currentPage > 1) {
        page.currentPage--;
        page.method();
      }
    },

    getPagination(board) {
      switch (board) {
        case "getTradingHistory":
          return this.tradingHistoryPage;
          break;
        case "getKRWHistory":
          return this.krwHistoryPage;
          break;
        case "getCoinHistory":
          return this.coinHistoryPage;
          break;
      }
    },
  },
  components: {
    Pagination,
    TabMenu,
  },
};
</script>
<style lang="scss" scoped>
.coin-name {
  font-size: 10px;
  color: #999;
  text-align: right;
  margin-bottom: 10px;
  padding-top: 10px;
}
.rebase-title {
  padding: 14px 0 0 12px;
  color: #333;
  font-size: 13px;
  font-weight: bold;
}
.table {
  padding: 0 12px;
  font-size: 13px;
  margin-bottom: 13px;
  .table-wrap {
    padding-top: 16px;
    border: 1px solid #e6e6e6;
    .rate,
    .amount,
    .total {
      display: flex;
      padding: 0 20px;
    }
    .rate,
    .amount {
      margin-bottom: 8px;
    }
    .total {
      margin-bottom: 16px;
    }
  }
  .text {
    width: 100px;
    color: #424242;
  }
  .number {
    width: calc(100% - 100px);
    color: #222;
  }
  .time {
    display: flex;
    padding: 6px 20px;
    background: rgba(0, 0, 0, 0.03);
    .text {
      color: #727272;
    }
    .number {
      color: #999;
    }
  }
  .empty {
    margin: 20px auto;
  }
}
.scrollX {
  overflow-x: scroll;
  height: 48px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  .investList-menu {
    width: 454px;
    padding: 7px 12px;
    list-style: none;
    li {
      min-width: 88px;
      padding: 0 6px;
      margin-right: 8px;
      border: 1px solid #dcdfe3;
      border-radius: 52px;
      text-align: center;
      background-color: #fff;
      line-height: 32px;
      font-size: 12px;
      font-weight: normal;
      color: #333;
      &.active {
        border-color: #eb3246;
        background-color: #eb3246;
        color: #fff;
      }
    }
    a:last-child li {
      margin-right: 0;
    }
  }
}
.list-container {
  padding-top: 16px;
}
</style>
